import { createUseStyles } from 'react-jss'

export default createUseStyles({
  button: {
    fontFamily: 'BentonSansMedium'
  }
})
